module.exports = __webpack_public_path__ + "static/media/Jochen_Spicker.2675126c.jpg";